import { render, staticRenderFns } from "./waixiao.vue?vue&type=template&id=9d1d8792&scoped=true"
import script from "./waixiao.vue?vue&type=script&lang=js"
export * from "./waixiao.vue?vue&type=script&lang=js"
import style0 from "./waixiao.vue?vue&type=style&index=0&id=9d1d8792&prod&scoped=true&lang=css"
import style1 from "./waixiao.vue?vue&type=style&index=1&id=9d1d8792&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1d8792",
  null
  
)

export default component.exports